import { Link } from 'react-router-dom';
import { useFetch } from '@/hooks/useFetch';
import ApperIcon from '@/components/ApperIcon';
import { STATUS_PATH, loadPublicStatus, metaOf, overallOf } from '@/shared/status';
import { cn } from '@/lib/utils';
import { useT } from '@/shared/i18n';

/** Slim service-status line on the landing page. Quiet when all is well, loud when it isn't. */
export function StatusStrip() {
  const { t } = useT();
  const { data } = useFetch(loadPublicStatus, []);
  const overall = overallOf(data);
  if (!overall) return null;
  const meta = metaOf(overall);
  const ok = overall === 'Up';

  return (
    <div className={cn('flex justify-center px-5', ok ? 'pt-4' : 'border-b py-2.5', !ok && meta.badge)}>
      <Link
        to={STATUS_PATH}
        className={cn(
          'group inline-flex min-h-10 items-center gap-2 rounded-full px-3 text-sm transition-colors',
          ok ? 'border border-border/60 bg-card/60 text-muted-foreground hover:text-foreground' : 'font-medium',
        )}
      >
        <span className={cn('h-2 w-2 rounded-full', meta.dot, !ok && 'animate-pulse')} />
        {t(meta.headline)}
        <span className={cn('inline-flex items-center gap-1', ok ? 'text-primary' : 'underline-offset-4 group-hover:underline')}>
          {t('View status')}
          <ApperIcon name="ArrowRight" size={14} className="transition-transform group-hover:translate-x-0.5" />
        </span>
      </Link>
    </div>
  );
}

export default StatusStrip;
